import MapView = require("esri/views/MapView");
import ToolBar from "../Toolbar";
import ToolButton from "./toolButton";

// ViewInBingTool

export default class ViewInBingTool extends ToolButton {
  private eventHandler: IHandle;

  constructor(viewIn: MapView, toolbarIn: ToolBar) {
    super(viewIn, toolbarIn);
  }

  deactivateTool() {
    // console.log("measureDistanceTool deactivateTool")
    if (this.eventHandler) {
      this.eventHandler.remove();
    }
    document.body.style.cursor = "default";
  }

  // Put widgets on map view
  activateTool(event: any) {
    // console.log("ViewInBingTool start");
    try {
      this.iconDiv = event.currentTarget;

      if (this.toolbar) {
        this.toolbar.setActiveTool(this as ToolButton);
      }
      if (this.view) {
        this.view.focus();
        document.body.style.cursor = "crosshair";

        this.eventHandler = this.view.on("click", mouseEvent => {
          // https://www.bing.com/maps?q=41.8843414,-87.64802&cp=47.677797~-122.122013&lvl=17
          const url =
            "https://www.bing.com/maps?q=" +
            mouseEvent.mapPoint.latitude +
            "," +
            mouseEvent.mapPoint.longitude +
            "&cp=" +
            mouseEvent.mapPoint.latitude +
            "~" +
            mouseEvent.mapPoint.longitude +
            "&lvl=17";
          window.open(url);
          mouseEvent.stopPropagation();
          this.toolbar.setPanAsActiveTool();
        });
      }
    } catch (error) {
      console.error("Error: in ViewInBingTool " + +error.message);
    }
  }
}
